import {DiscountCoupon, DiscountCouponType} from '@web/core/constants'

interface GetOrderTotalParams {
    /** 배송비 */
    deliveryFeeAmount: number
    /** 배송비 할인 총액 */
    deliveryDiscountAmount: number
    /** 주문 금액 */
    orderAmount: number
    /** 쿠폰 타입 별 할인 총계 */
    productDiscountAmountByDiscountType: Record<DiscountCouponType, number>
    /** 할인 총계 */
    totalDiscountAmount: number
    /** 매 결제시 쿠폰 사용 여부 */
    useAllCoupon: boolean
}

/** 매 결제시 쿠폰 모두사용 여부 Y 일때만 적용되는 쿠폰 종류 */
const optionallyAppliedDiscountTypes: DiscountCouponType[] = [
    DiscountCoupon.MANAGER_PRODUCT_DISCOUNT,
    DiscountCoupon.SELLER_PRODUCT_DISCOUNT,
    DiscountCoupon.DUPLICATE_PRODUCT_DISCOUNT,
    DiscountCoupon.STORE_DISCOUNT,
    DiscountCoupon.DELIVERY_DISCOUNT,
]

export const getOrderTotal = ({
    deliveryFeeAmount,
    deliveryDiscountAmount,
    orderAmount,
    totalDiscountAmount,
    productDiscountAmountByDiscountType,
    useAllCoupon,
}: GetOrderTotalParams) => {
    /** 매 결제시 쿠폰 모두 사용이 false인 경우 할인에서 제외되는 금액 */
    const optionallyAppliedDiscountAmount = optionallyAppliedDiscountTypes.reduce((acc, type) => {
        return acc + productDiscountAmountByDiscountType[type]
    }, deliveryDiscountAmount)

    const firstSubscriptionDiscount = productDiscountAmountByDiscountType.SUBSCRIPTION_DISCOUNT

    /**
     * 할인 금액
     * useAllCoupon이 false라면 optionallyAppliedDiscountAmount를 빼고 계산
     */
    const discountAmount = totalDiscountAmount - (useAllCoupon ? 0 : optionallyAppliedDiscountAmount)
    const totalAmount = orderAmount + deliveryFeeAmount - discountAmount

    return {
        firstSubscriptionDiscount,
        discountAmount,
        totalAmount,
    }
}
